import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Row, Col, Container } from 'react-bootstrap';
import { useTrackVisibility } from 'react-intersection-observer-hook';
// api
import { searchFilterProduct } from 'api/products';
//helpers
import { goUp } from 'helpers';
// components
import ItemList from 'components/itemList/item';
import PaginationLoader from 'components/loader/PaginationLoader';
import Head from 'components/metatags_helmet/metatags';
import BreadCrumb from 'components/breadcrumb/BreadCrumb';

const CardDetail = () => {
  const location = useLocation();
  const [products, setProducts] = useState([]);
  //pagination
  const [ref, { isVisible }] = useTrackVisibility();
  const [isLoading, setIsLoading] = useState(true);
  const [next, setNext] = useState(null);
  const [maxPage, setMaxPage] = useState(null);
  const [page, setPage] = useState(1);
  const type = location?.pathname.includes('autor') ? 'autor' : 'editorial';
  const [listName, setListName] = useState(location?.state || 'Resultados');

  const getProducts = async (page = 1) => {
    setIsLoading(true);
    const payload = {
      page,
      page_size: 18,
      book_ibic: '',
      book_type: '',
      idioma: '',
      search_all_fields: '',
      titulo: '',
      ean: '',
      autor: '',
      editorial: '',
      fields: 'id,image,titulo,price,discount,fecha_public,type,languages,authors,has_stock,has_used,has_newbalance',
    };
    if (type === 'autor') {
      payload.autor = location?.state;
    } else if (type === 'editorial') {
      payload.editorial = location?.state;
    }
    try {
      const response = await searchFilterProduct(payload);
      if (response) {
        const { status, data } = response;
        if (status === 200) {
          if (page === 1) {
            let name = location?.state || 'Resultados';
            if (type === 'autor') {
              const fullName = data?.results?.[0]?.authors?.[0]?.nombre_autor || location?.state || 'Resultados';
              if (fullName.includes(',')) {
                const [lastName, firstName] = fullName.split(',').map((s) => s.trim());
                name = `${firstName} ${lastName}`;
              } else {
                name = fullName;
              }
            }
            setListName(name);
            goUp();
            setProducts(data?.results);
          } else {
            setProducts((prev) => [...(prev || []), ...data?.results]);
          }
          setMaxPage(data?.total_pages || Math.ceil(data?.count / 18));
          setNext(data?.next);
        } else {
          console.error('Error: Unexpected status code', status);
        }
      } else {
        console.error('Error: Response is undefined');
      }
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getProducts();
  }, [location]);

  // next API calls
  useEffect(() => {
    if (page < maxPage && next) {
      const getNewItems = async (newValuePage) => {
        await getProducts(newValuePage);
        setPage(newValuePage);
      };
      if (isVisible) {
        let newValuePage = page + 1;
        getNewItems(newValuePage);
      }
    }
  }, [isVisible, page, next, maxPage]);

  return (
    <>
      <Head title={listName} />
      <Container className="margin-bottom-md px-0 list-section container-fluid">
        <Row className="p-0">
          <BreadCrumb breadcrumbTitle={listName} />
        </Row>
        <Row className="itemsRow">
          {products?.map((item, index) => (
            <Col md={4} lg={2} sm={6} key={`itmes#${index}`} className="mb-5">
              <ItemList key={index} data={item} />
            </Col>
          ))}
          {!isLoading && next && <div aria-hidden="true" ref={ref}></div>}
          {isLoading && (
            <div className="container">
              <PaginationLoader visibility={isLoading} />
            </div>
          )}
        </Row>
      </Container>
    </>
  );
};
export default CardDetail;
